import Service from "../Service";

const overviewTable = {

    getAllDataTopic() {
        return Service.get(`/api/frontend/data/overview`);
    }

};

export default overviewTable;
